export const songs = [
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/p10.jpg",
    title: "AGABA",
    artist: "Praizsingz",
    mp3: new Audio("/Assets/mp3/Agaba.mp3"),
  },
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/p11.jpg",
    title: "Aya o Aya  Adullam",
    artist: "Theophilus Sunday",
    mp3: new Audio("/Assets/mp3/Aya o Aya  Adullam.mp3"),
  },
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/p2.jpg",
    title: "Bi Gbogbo Irun mi",
    artist: "Evang Toyin Leshin",
    mp3: new Audio("/Assets/mp3/Bi Gbogbo Irun mi.mp3"),
  },
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/p3.jpg",
    title: "Chants",
    artist: "Theophilus Sunday",
    mp3: new Audio("/Assets/mp3/Chants Theophilus.mp3"),
  },
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/p4.jpg",
    title: "Mantles Are Falling",
    artist: "Dr Paul Enenche",
    mp3: new Audio("/Assets/mp3/Mantles Are Falling.mp3"),
  },
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/p5.jpg",
    title: "Fountain",
    artist: "JudiKay",
    mp3: new Audio("/Assets/mp3/Fountain.mp3"),
  },
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/p6.jpg",
    title: "Oh Find Me Lord",
    artist: "Theophilus Sunday",
    mp3: new Audio("/Assets/mp3/Oh Find Me Lord.mp3"),
  },
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/p8.jpg",
    title: "Holyghost Come For Me",
    artist: "Theophilus Sunday",
    mp3: new Audio("/Assets/mp3/Holyghost Come For Me.mp3"),
  },
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/p9.jpg",
    title: "Sovereign Over Us",
    artist: "Michael W Smith",
    mp3: new Audio("/Assets/mp3/Sovereign Over Us.mp3"),
  },
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/p7.jpg",
    title: "Take it Away",
    artist: "Theophilus Sunday",
    mp3: new Audio("/Assets/mp3/Take it Away.mp3"),
  },
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/p11.jpg",
    title: "Spirit_Of_Prophecy",
    artist: "Omo_Baba",
    mp3: new Audio("/Assets/mp3/Spirit_Of_Prophecy_.mp3"),
  },
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/worship.jpg",
    title: "Sing Halleluyah To The Lamb",
    artist: "Theophilus Sunday",
    mp3: new Audio("/Assets/mp3/Sing Halleluyah To The Lord.m4a"),
  },
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/02.jpg",
    title: "Show us the Ancient Paths",
    artist: "Theophilus Sunday",
    mp3: new Audio("/Assets/mp3/Show us the Ancient Paths.mp3"),
  },
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/03.jpg",
    title: "This Is the place of encounter",
    artist: "Dunsin Oyekan",
    mp3: new Audio("/Assets/mp3/This Is the place of encounter.mp3"),
  },
  {
    id: Math.random() * Date.now(),
    img: "/Assets/img/04.jpg",
    title: "Soaking Chants",
    artist: "Praizsingz",
    mp3: new Audio("/Assets/mp3/Soaking Chants.mp3"),
  },
];

export const cardsData = [
  {
    id: 1,
    img: "/Assets/img/02.jpg",
    title: "Your Mix",
    artist: "Theophilus Sunday, Blessing Onuche",
  },
  {
    id: 2,
    img: "/Assets/img/p1.jpg",
    title: "Soaking Worship",
    artist: "Theophilus Sunday",
  },
  {
    id: 3,
    img: "/Assets/img/p2.jpg",
    title: "Classicals & Hymns",
    artist: "Bill Gaither",
  },
  {
    id: 4,
    img: "/Assets/img/p3.jpg",
    title: "Praise",
    artist: "Bidemi Olaoba",
  },
  {
    id: 5,
    img: "/Assets/img/audio_bible.jpg",
    title: "Audio Bible",
    artist: "KJV Dramatized",
  },
  {
    id: 6,
    img: "/Assets/img/p6.jpg",
    title: "Afro Gospel",
    artist: "LimoBlaze",
  },
  {
    id: 7,
    img: "/Assets/img/pray.jpg",
    title: "Prayer Chants",
    artist: "Lawrence Oyor, EbukaSongs",
  },
];

export const LiveData = [
  {
    id: 1,
    img: "/Assets/img/zz.jpg",
    title: "Halleluyah Challenge",
    artist: "NathanielBlow",
    live: "33.4k",
  },
  {
    id: 2,
    img: "/Assets/img/p11.jpg",
    title: "The Outpouring",
    artist: "Dunsin Oyekan",
    live: "23.4k",
  },
  {
    id: 3,
    img: "/Assets/img/yy.jpg",
    title: "True Worshippers",
    artist: "Theophilus Sunday",
    live: "43.4k",
  },
  {
    id: 4,
    img: "/Assets/img/cc.jpg",
    title: "Koinonia",
    artist: "Apst Joshua Selman",
    live: "113.4k",
  },
  {
    id: 5,
    img: "/Assets/img/p5.jpg",
    title: "NSSPD Prayers",
    artist: "Pst Jerry Eze",
    live: "73.4k",
  },
  {
    id: 6,
    img: "/Assets/img/aa.jpg",
    title: "NLP",
    artist: "Pst Bolaji Idowu",
    live: "3.4k",
  },
];
